import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const VerifyOTP = () => {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [resendSuccess, setResendSuccess] = useState("");
  const [emailResendSuccess, setEmailResendSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const email = localStorage.getItem("pending_email");

  const handleVerify = async () => {
    if (!otp.trim()) return setError("OTP is required.");
    if (!email) return setError("Missing email. Please sign up again.");

    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/login/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, otp }),
      });

      const result = await res.json();
      if (!result.success) {
        setError(result.error || "Invalid OTP");
        setLoading(false);
        return;
      }

      localStorage.removeItem("pending_email");
      navigate("/login");
    } catch (err) {
      console.error("OTP verification failed:", err);
      setError("Server error. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {
    setError("");
    setResendSuccess("");
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/login/resend-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email }),
      });
      const result = await res.json();
      if (!result.success) return setError(result.error || "Failed to resend OTP");
      setResendSuccess("✅ OTP resent successfully to your email.");
    } catch (err) {
      console.error("Resend OTP error:", err);
      setError("Could not resend OTP. Try again later.");
    }
  };

  const handleResendEmailLink = async () => {
    setError("");
    setEmailResendSuccess("");
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/resend-verification-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const result = await res.json();
      if (!result.success) return setError(result.error || "Failed to resend verification email");
      setEmailResendSuccess("✅ Verification email resent successfully.");
    } catch (err) {
      console.error("Resend email error:", err);
      setError("Could not resend email. Try again later.");
    }
  };

  return (
    <div style={styles.container}>
      <h2>Enter OTP</h2>
      <input
        type="text"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        placeholder="One-Time Password"
        style={styles.input}
      />
      {error && <p style={styles.error}>{error}</p>}
      {resendSuccess && <p style={styles.success}>{resendSuccess}</p>}
      {emailResendSuccess && <p style={styles.success}>{emailResendSuccess}</p>}

      <button onClick={handleVerify} style={styles.button} disabled={loading}>
        {loading ? "Verifying..." : "Verify"}
      </button>

      <button onClick={handleResendOTP} style={styles.linkButton}>
        Didn't receive code? Resend OTP
      </button>

      <button onClick={handleResendEmailLink} style={styles.linkButton}>
        Didn't receive email? Resend verification email
      </button>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "400px",
    margin: "100px auto",
    textAlign: "center",
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "8px",
  },
  input: {
    padding: "10px",
    width: "100%",
    marginBottom: "10px",
  },
  button: {
    padding: "10px 20px",
    backgroundColor: "#1E2A78",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginTop: "10px",
    opacity: 1,
  },
  linkButton: {
    background: "none",
    border: "none",
    color: "#1E2A78",
    textDecoration: "underline",
    cursor: "pointer",
    marginTop: "12px",
    display: "block",
  },
  error: {
    color: "red",
    fontSize: "14px",
  },
  success: {
    color: "green",
    fontSize: "14px",
  },
};

export default VerifyOTP;
